import { css } from "@emotion/react"

import Image from "@p-ban/common/src/components/html/Image"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import COLOR_CODE from "../../../features/oneClickEstimate/pcb/constant/color"

import alertIcon from "./alert.svg"

type Props = {
  children: string
  multi?: boolean
}

const ErrorText = ({ children, multi = false }: Props) => {
  return (
    <p css={css(styles.base, multi && styles.multi)}>
      <Image src={alertIcon} alt="" css={styles.icon} width={14} height={14} role="presentation" clearExtraSpace />
      <Spacer size={5} />
      {children}
    </p>
  )
}

export default ErrorText

const styles = {
  base: css`
    display: flex;
    align-items: center;
    font-size: 14px;
    color: ${COLOR_CODE.RED};
  `,
  multi: css`
    line-height: 20px;
  `,
  /** 微妙に中央からずれて見えるので位置の調整をしています。 */
  icon: css`
    position: relative;
    bottom: 1px;
  `,
}
